import { render, staticRenderFns } from "./adminPersonal.vue?vue&type=template&id=68f4b603&scoped=true"
import script from "./adminPersonal.vue?vue&type=script&lang=js"
export * from "./adminPersonal.vue?vue&type=script&lang=js"
import style0 from "./adminPersonal.vue?vue&type=style&index=0&id=68f4b603&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f4b603",
  null
  
)

export default component.exports